export const I18N_CONFIG = {
  defaultLang: 'en-US',
  supported: [
    'pt-BR', 
    'en-US',
  ] as const,
  routeMap: {
    'pt-BR': 'pt',
    'en-US': 'en',
  } as const,
  ogLocaleMap: {
    'pt-BR': 'pt_BR',
    'en-US': 'en_US',
  } as const,
  labelMap: {
    'pt-BR': 'PT',
    'en-US': 'EN',
  } as const,
} as const;

export type SupportedLang = (typeof I18N_CONFIG.supported)[number];

export function isSupportedLang(lang: string | null | undefined): lang is SupportedLang {
  return !!lang && (I18N_CONFIG.supported as readonly string[]).includes(lang);
}

export function normalizeLang(lang: string | null | undefined): SupportedLang {
  return isSupportedLang(lang) ? lang : I18N_CONFIG.defaultLang;
}

export function langToRoute(lang: SupportedLang): string {
  return I18N_CONFIG.routeMap[lang];
}

export function routeToLang(pathname: string): SupportedLang {
  const segment = pathname.split('/').filter(Boolean)[0] ?? '';
  const entries = Object.entries(I18N_CONFIG.routeMap) as [SupportedLang, string][];
  const match = entries.find(([, route]) => route === segment);
  return match ? match[0] : I18N_CONFIG.defaultLang;
}

export function langToOgLocale(lang: SupportedLang): string {
  return I18N_CONFIG.ogLocaleMap[lang];
}

export function getAlternateOgLocales(lang: SupportedLang): string[] {
  return I18N_CONFIG.supported
    .filter((candidate) => candidate !== lang)
    .map(langToOgLocale);
}
